import React, { useEffect, useRef, useState } from "react";
import SmartPopup from "../../components/Dailogs/SmartPopup";
import { useLocation } from "react-router-dom";
import {
  AddTaskProductParts,
  UpdateTaskProductParts,
  FetchTaskProductParts,
  DeleteTaskProductParts,
  UpdateTaskProductPartQtyData,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import PlusIcon from "../../assets/icons/Plus-border-white.svg";
import "./Activity.css";
import CurrencyInput from "react-currency-input";
import { Tooltip } from "antd";
import moment from "moment";
import TaskProductsPartsPopup from "./TaskProductsPartsPopup";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";

const createEmptyRow = () => ({
  productPartid: `task-${Date.now()}-${Math.random()}`,
  productPartName: "",
  unit: "",
  unitPrice: "",
  qty: "1",
});

const TaskProductsPart = ({
  taskId,
  modalFunction,
  onProductsChange,
  ...rest
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");

  const [anchorEl, setAnchorEl] = useState(null);

  const [fetchTransUpdateTaskList, setFetchTransUpdateTaskList] = useState({});

  useEffect(() => {
    fetchScreenTranslations("Updated-Task").then((res) => {
      setFetchTransUpdateTaskList(res);
    });
  }, []);

  const t = (key) => fetchTransUpdateTaskList?.[key] || "";

  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const [partsData, setPartsData] = useState([createEmptyRow()]);
  const [partsBoxOpen, setPartsBoxOpen] = useState(null);

  // Add new row
  const handleAddRow = (item) => {
    setPartsData((prevRows) => [...prevRows, createEmptyRow()]);

    dispatch(
      AddTaskProductParts({
        taskid: taskId,
        productPartid: item.productPartid,
        qty: Number(item.qty),
        unitPrice: Number(item.unitPrice || 0),
        total: Number(item.unitPrice || 0) * Number(item.qty || 0),
      }),
    );
  };

  useEffect(() => {
    const createdTaskId = addTaskResponse?.data?.taskid;
    if (modalFunction !== "add" || !createdTaskId) return;

    dispatch(
      AddTaskProductParts({
        taskid: createdTaskId,
        taskproductpart: partsData
          ?.filter((item) => item.productPartName && item.qty)
          ?.map((item) => ({
            productPartid: item.productPartid,
            qty: Number(item.qty),
            unitPrice: Number(item.unitPrice || 0),
            total: Number(item.unitPrice || 0) * Number(item.qty || 0),
          })),
      }),
    );
  }, [modalFunction, addTaskResponse]);

  const handleChange2 = (index, field, value) => {
    const list = [...partsData];
    list[index][field] = value;

    setPartsData(list);
  };

  // Update row field
  const handleChange = (index, field, value) => {
    setPartsData((prevRows) =>
      prevRows.map((row, i) =>
        i === index ? { ...row, [field]: value } : row,
      ),
    );

    const item = partsData[index];

    dispatch(
      UpdateTaskProductParts({
        taskProductPartid: item.taskProductPartid,
        qty: Number(field === "qty" ? value : item.qty || 0),
        unitPrice: Number(field === "unitPrice" ? value : item.unitPrice || 0),
        total:
          Number(field === "qty" ? value : item.qty || 0) *
          Number(field === "unitPrice" ? value : item.unitPrice || 0),
      }),
    );

    if (field === "qty") {
      dispatch(
        UpdateTaskProductPartQtyData({
          productPartQty: [
            {
              taskProductPartid: item.taskProductPartid,
              qty: Number(value),
            },
          ],
        }),
      );
    }
  };

  // Delete row
  const handleDeleteRow = (productPartid) => {
    setPartsData((prevRows) =>
      prevRows.filter((row) => row.productPartid !== productPartid),
    );
  };

  const handleSelectedParts2 = (selectedParts, index) => {
    console.log("asc445", selectedParts);
    setPartsData((prev) =>
      prev.map((row, i) =>
        i === index
          ? {
              ...row,
              ...selectedParts,
              unitPrice: Number(
                selectedParts?.salePriceexcvat?.replace(",", ".") || 0,
              ),
            }
          : row,
      ),
    );
  };

  const handleSelectedPartsSingle = (selectedParts) => {
    setPartsData((prevRows) => {
      const existingRows = prevRows.filter((row) => row.productPartName);

      const updatedRows = selectedParts.map((part) => {
        const existingRow = existingRows.find(
          (row) => row.productPartid === part.productPartid,
        );

        if (existingRow) return existingRow;

        const newRow = {
          ...createEmptyRow(),
          ...part,
          unitPrice: Number(
            String(part.salePriceexcvat ?? part.unitPrice ?? 0).replace(
              ",",
              ".",
            ),
          ),
          qty: "1",
        };

        // API call for newly selected product
        handleAddRow(newRow);

        return newRow;
      });

      return [...updatedRows, createEmptyRow()];
    });
  };

  const handleSelectedParts = (selectedParts) => {
    setPartsData((prevRows) => {
      const existingRows = prevRows.filter((row) => row.productPartName);

      const newParts = selectedParts
        .filter(
          (part) =>
            !existingRows.some(
              (row) => row.productPartid === part.productPartid,
            ),
        )
        .map((part) => ({
          ...createEmptyRow(),
          ...part,
          unitPrice: Number(
            String(part.salePriceexcvat ?? part.unitPrice ?? 0).replace(
              ",",
              ".",
            ),
          ),
          qty: "1",
        }));

      if (newParts.length > 0) {
        dispatch(
          AddTaskProductParts({
            taskid: taskId,
            taskproductpart: newParts.map((item) => ({
              productPartid: item.productPartid,
              qty: Number(item.qty || 1),
              unitPrice: Number(item.unitPrice || 0),
              total: Number(item.unitPrice || 0) * Number(item.qty || 1),
            })),
          }),
        );
      }

      return [...existingRows, ...newParts, createEmptyRow()];
    });
  };

  useEffect(() => {
    if (modalFunction === "update") {
      dispatch(
        FetchTaskProductParts({
          taskid: taskId,
        }),
      ).then((res) => {
        setPartsData([...res?.data, createEmptyRow()]);
      });
    }
  }, [modalFunction]);

  useEffect(() => {
    onProductsChange?.(partsData);
  }, [partsData, onProductsChange]);

  return (
    <div style={{ marginTop: "2rem", position: "relative" }}>
      <div
        id="actiTable"
        className="task-modal-dependencies-box-1 px-0 pb-"
        style={{
          color: "#333333",
          ...rest.actiTable,
        }}
      >
        <p className="mb-2" style={{ paddingLeft: "32px" }}>
          {/* Product & Services */}
          {t("Product & Services")}
        </p>
        <table className="table">
          <thead>
            <tr className="atitableHeading">
              <th
                className="activityTH2 fw-bold"
                style={{ paddingLeft: "33px" }}
              >
                <span style={{ textTransform: "uppercase", color: "black" }}>
                  {/* {t("Production")} */}
                </span>
                <br />
                {t("Parts")}
              </th>
              <th
                className="activityTH2 fw-bold"
                style={{ width: "", paddingLeft: "15px" }}
              >
                {t("Unit")}
              </th>
              <th className="activityTH2" style={{ width: "" }}>
                {t("Unit price")}
              </th>
              <th className="activityTH2" style={{ width: "" }}>
                {t("Quantity")}
              </th>
              <th className="activityTH2" style={{ width: "" }}>
                {t("Total")}
              </th>
              <th className="activityTH2" style={{ width: "" }}>
                {t("")}
              </th>
            </tr>
          </thead>

          <tbody className="tabLine">
            {partsData.map((item, index) => {
              return (
                <tr
                  key={index}
                  style={{
                    verticalAlign: "middle",
                    // borderBottom: "0.5px dotted #A5A5A5",
                  }}
                >
                  <td
                    className="position-relative"
                    style={{ paddingLeft: "30px" }}
                  >
                    <div className="d-flex gap-1">
                      <input
                        title={item.productPartName || ""}
                        readOnly
                        disabled={!!item.taskProductPartid}
                        className="activityinput truncate pointer"
                        placeholder={t("Add a part")}
                        value={item.productPartName || ""}
                        onClick={(e) => {
                          setPartsBoxOpen(index);
                          setAnchorEl(e.currentTarget);
                        }}
                      />

                      {partsBoxOpen === index && (
                        <SmartPopup
                          open={Boolean(anchorEl)}
                          anchorEl={anchorEl}
                          style={{ zIndex: 9999 }}
                        >
                          <TaskProductsPartsPopup
                            taskId={taskId}
                            currentPartId={item.productPartid}
                            parentSelectedParts={partsData}
                            onSelectParts={(data) =>
                              handleSelectedParts(data, index)
                            }
                            onClose={() => {
                              setPartsBoxOpen(null);
                              setAnchorEl(null);
                            }}
                          />
                        </SmartPopup>
                      )}
                    </div>
                  </td>

                  {/* unit */}
                  <td>
                    <input
                      type="text"
                      className="acti-form-control"
                      placeholder="unit"
                      readOnly
                      disabled={!!item.taskProductPartid}
                      // value={item.unit}
                      value={item.productPartName ? item.unit || "-" : ""}
                      onChange={(e) =>
                        handleChange(index, "unit", e.target.value)
                      }
                      style={{ width: "80px" }}
                    />
                  </td>

                  {/* unit price */}
                  <td>
                    <CurrencyInput
                      className="acti-form-control"
                      placeholder="0"
                      readOnly
                      disabled={!!item.taskProductPartid}
                      value={item.unitPrice}
                      decimalSeparator=","
                      thousandSeparator="."
                      precision="2"
                      allowEmpty={true}
                      prefix="€ "
                      style={{
                        // border: fieldErrors?.[index]?.costprice
                        //   ? "1px solid red"
                        //   : "",
                        border: "none",
                        width: "100px",
                        minWidth: "70px",
                      }}
                      onChange={(event, value) => {
                        handleChange(index, "unitPrice", Number(value));
                      }}
                    />
                  </td>

                  {/* qty */}
                  <td>
                    <input
                      type="number"
                      className="acti-form-control"
                      placeholder="0"
                      // value={item.qty}
                      value={item.productPartName ? item.qty || "-" : ""}
                      onChange={(e) =>
                        handleChange(index, "qty", e.target.value)
                      }
                      style={{ width: "60px" }}
                    />
                  </td>

                  {/* total */}
                  <td>
                    {europeanFormatWithSymbol(
                      Number(String(item.unitPrice || 0).replace(",", ".")) *
                        Number(item.qty || 0),
                    )}
                  </td>
                  <td className="text-end">
                    {index === partsData.length - 1 && (
                      <img
                        src={PlusIcon}
                        alt=""
                        className="pointer d-none"
                        onClick={() => {
                          if (
                            item.productPartName === "" ||
                            item.unit === "" ||
                            item.unitPrice === "" ||
                            item.qty === ""
                          ) {
                            return;
                          }
                          handleAddRow(item);
                        }}
                      />
                    )}

                    {index !== partsData.length - 1 && (
                      <img
                        src={DeleteIcon}
                        alt=""
                        width={15}
                        className="ms-1 pointer opacity-50"
                        onClick={() => {
                          handleDeleteRow(item.productPartid);
                          if (item.taskProductPartid) {
                            dispatch(
                              DeleteTaskProductParts({
                                taskProductPartid: item.taskProductPartid,
                              }),
                            );
                          }
                        }}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TaskProductsPart;
